module.exports = __webpack_public_path__ + "img/img_case3.e1a2dcd6.png";